/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  SearchInputComponent,
  Button
} from "../../../common/components";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import { LeadFilterProps } from "./lead-filter.props";
import "./lead-filter.scss";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";


const LeadFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedLeadsFilter,
    onSearch,
    searchRef,
    isResetSearch,
    handleClickCreateNewForm,
    selectedLeadsFilterCount
  } = props;
  const { canWrite } = useResourcePermissions(
    MODULES.LEAD_CAPTURE
  );

  return (
    <div className="lead-capture-lead-list-search-filter-wrapper">
      <div className="lead-capture-lead-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by Lead name, Email, Lead owner etc."
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-capture-lead-list-filter-wrapper">
        <div
          className="lead-capture-lead-list-icon-filter"
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge color="secondary" badgeContent={selectedLeadsFilterCount}>
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
        {canWrite && (
          <div className="lead-capture-lead-list-create-filter">
            <Button
            label="Find Duplicates"
            onClick={handleClickCreateNewForm}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadFilter;
